import React from "react";
import "./BackedAdvised.css";
function BackedAdvised() {
  return (
    <React.Fragment>
      <div className="BackedAdvisedWrapper">
        <div className="BackedAdvisedHeading">Backed & Advised By</div>
        <div className="BackedAdvisedGridLayout">
          <div className="BackedAdvisedLeaderIcon">
            <div className="BackedAdvisedImageDiv">
              <img
                src="https://ik.imagekit.io/driveu/Web/unitus_E8PcgUWGt.png"
                alt="Unitus Ventures"
                width={"100%"}
                height={"100%"}
                loading="lazy"
              />
            </div>
            <div className="BackedAdvisedName">Unitus Ventures</div>
            <div className="BackedAdvisedRole">VC Investor</div>
          </div>
          <div className="BackedAdvisedLeaderIcon">
            <div className="BackedAdvisedImageDiv">
              <img
                src="https://ik.imagekit.io/driveu/Web/stevens_yqByE7fCo.png"
                alt="Stevens Creek Ventures"
                width={"100%"}
                height={"100%"}
                loading="lazy"
              />
            </div>
            <div className="BackedAdvisedName">Stevens Creek Ventures</div>
            <div className="BackedAdvisedRole">VC Investor</div>
          </div>
          <div className="BackedAdvisedLeaderIcon">
            <div className="BackedAdvisedImageDiv">
              <img
                src="https://ik.imagekit.io/driveu/Web/pcaptial_Ab_wp0wlO.png"
                alt="Patamar Capital"
                width={"100%"}
                height={"100%"}
                loading="lazy"
              />
            </div>
            <div className="BackedAdvisedName">Patamar Capital</div>
            <div className="BackedAdvisedRole">VC Investor</div>
          </div>
          <div className="BackedAdvisedLeaderIcon">
            <div className="BackedAdvisedImageDiv">
              <img
                src="https://ik.imagekit.io/driveu/Web/image__2__WpCvu9HgM.png"
                alt="Geoff Wooley"
                width={"100%"}
                height={"100%"}
                loading="lazy"
              />
            </div>
            <div className="BackedAdvisedName">Geoff Wooley</div>
            <div className="BackedAdvisedRole">Marquee Investor</div>
          </div>
          <div className="BackedAdvisedLeaderIcon">
            <div className="BackedAdvisedImageDiv">
              <img
                src="https://ik.imagekit.io/driveu/Web/image__1__NHuHIgd1L.png"
                alt="Rajeev Madhavan"
                width={"100%"}
                height={"100%"}
                loading="lazy"
              />
            </div>
            <div className="BackedAdvisedName">Rajeev Madhavan</div>
            <div className="BackedAdvisedRole">Marquee Investor</div>
          </div>
          <div className="BackedAdvisedLeaderIcon">
            <div className="BackedAdvisedImageDiv">
              <img
                src="https://ik.imagekit.io/driveu/Web/Amit_Singhal_iBvnOEQKE.png"
                alt="Amit Singhal"
                width={"100%"}
                height={"100%"}
                loading="lazy"
              />
            </div>
            <div className="BackedAdvisedName">Amit Singhal</div>
            <div className="BackedAdvisedRole">Marquee Investor</div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default BackedAdvised;
